import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-bootstrap';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Paper from '@material-ui/core/Paper';
import 'typeface-roboto';
import Modal from 'react-modal';
import KlantForm from './KlantForm';
import { Redirect } from 'react-router-dom';
import { firebase } from '../../models/firestore';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)'
  }
};
const styles = {
  containerModal: {
    display: 'flex',
    flexWrap: 'wrap',
    fontSize: 14
  },
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  row: {
    display: 'flex',
    flexDirection: 'row'
    //alignItems: "center"
  },
  checkbox: {
    marginLeft: 16,
    width: 40
  },
  input: {
    flex: 1
    //alignContent: "flex-start",
    //justifyContent: "flex-start"
  },
  icongreen: {
    marginRight: 6,
    color: 'green'
  },
  iconred: {
    marginRight: 6,
    color: 'red'
  },
  subtitle: {
    fontSize: 14,
    fontWeight: 'bold',
    color: 'blue'
  },
  naam: {
    width: '90%'
    //alignSelf: "flex-start"
  },
  sluitbutton: {
    backgroundcolor: '#00FF00'
  }
};

const myVrijwilliger = {
  marginTop: 0,
  marginLeft: 20,
  //width: 200,
  float: 'left',
  color: 'blue'

  //fontSize: "24"
  //width: "80%"
};

class Klant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      module: '',
      navigate: false
    };
    this.openModal = this.openModal.bind(this);
    //this.openModalOpdracht = this.openModalOpdracht.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true, module: 'wijzigenklant' });
  }
  // openModalOpdracht() {
  //   this.setState({ modalIsOpen: true, module: 'opdrachten' });
  // }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    this.subtitle.style.color = 'blue';
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }
  static propTypes = {
    klant: PropTypes.any
  };

  handleChange = name => event => {
    const { klant, gebruikersNaam } = this.props;
    klant.update({
      [name]: event.target.value,
      zz_lastupdate: new Date().toLocaleDateString('nl-NL') + ' ' + new Date().toLocaleTimeString('nl-NL'),
      zz_gebruikersNaam: gebruikersNaam
    });
  };

  render() {
    const { navigate } = this.state;
    const { klant, gebruikersNaam, gebruikersrollen } = this.props;
    const {
      initialen,
      voornaam,
      tussenvoegsel,
      achternaam,
      geslacht,
      adres,
      postcode,
      woonplaats,
      huisnummer,
      toevoegsel,
      telefoon,
      zz_lastupdate,
      zz_gebruikersNaam
    } = klant.data;

    if (navigate) {
      const that = this;
      let opdracht = '';
      // opdrachten.add({ achternaam: achternaam, datumopdracht: new Date().toDateString('yyyy-MM-dd') });
      if (this.state.chauffeur) {
        opdracht = 'Chauffeur';
      }
      if (this.state.chauffeurinstellingen) {
        opdracht = 'ChauffeurInstellingen';
      }
      if (this.state.blanco) {
        opdracht = '';
      }
      if (this.state.boodschap) {
        opdracht = 'Boodschap';
      }
      if (this.state.electra) {
        opdracht = 'Electra';
      }
      if (this.state.techniek) {
        opdracht = 'Techniek';
      }
      if (this.state.timmeren) {
        opdracht = 'Timmeren';
      }
      if (this.state.wandelen) {
        opdracht = 'Wandelen';
      }
      if (this.state.tuin) {
        opdracht = 'Tuin';
      }
      if (this.state.liefenleed) {
        opdracht = 'Lief_en_leed';
      }
      if (this.state.pr) {
        opdracht = 'PR';
      }
      if (this.state.algemeneklusjes) {
        opdracht = 'Algemeneklusjes';
      }
      if (this.state.klusseninstellingen) {
        opdracht = 'KlussenInstellingen';
      }

      let adresnw = adres;
      let huisnummernw = huisnummer || '';
      let toevoegselnw = toevoegsel || '';
      let compleetadres = `${adresnw} ${huisnummernw} ${toevoegselnw}`;

      firebase
        .firestore()
        .collection('opdrachten')
        //.doc('123456789')
        .add({
          geslacht: geslacht,
          tussenvoegsel: tussenvoegsel || '',
          initialen: initialen || '',
          achternaam: achternaam || '',
          voornaam: voornaam || '',
          adres: compleetadres,
          huisnummer: huisnummer || '',
          toevoegsel: toevoegsel || '',
          postcode: postcode,
          woonplaats: woonplaats,
          telefoon: telefoon || '',
          datumopdracht: new Date().toDateString('yyyy-MM-dd'),
          typeopdracht: opdracht,
          opdrachtuitgevoerd: false,
          timestamp: Date.now(),
          uitvoeringsdatumtimestamp: Date.now(),
          datumuitvoering: new Date().toDateString('yyyy-MM-dd')
        })
        .then(function(doc) {
          //console.log(doc.id);
          that.setState({ navigate: false, modalIsOpen: false });
        })
        .catch(function(error) {
          console.log('Error writing document ', error);
        });
      //setTimeout(1000);
      return <Redirect to="/opdrachten" push={true} />;
    }
    //console.log("TodoItem.render: ", vrijwilliger.path, ", text: ", text);
    return (
      <div>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={[customStyles, 'pre-scrollable']}
          contentLabel="Wijzig klant"
        >
          <h3 style={styles.subtitle} ref={subtitle => (this.subtitle = subtitle)}>
            Wijzigen van: {voornaam} {tussenvoegsel || ''} {achternaam || ''}
          </h3>
          <div>
            {this.state.module === 'wijzigenklant' && (
              <KlantForm klant={klant} gebruikersNaam={gebruikersNaam} gebruikersrollen={gebruikersrollen} />
            )}
            {/* {this.state.module === 'opdrachten' && (
              <Opdracht
                klant={klant}
                opdracht={opdracht}
                gebruikersNaam={gebruikersNaam}
                gebruikersrollen={gebruikersrollen}
              />
            )} */}
          </div>
          <p />
          <Button
            style={{ marginRight: 30, marginBottom: 10 }}
            variant="contained"
            color="primary"
            onClick={this.closeModal}
          >
            Annuleer
          </Button>
          <Button
            disabled={
              adres === undefined || huisnummer === undefined || postcode === undefined || woonplaats === undefined
            }
            variant="contained"
            color="primary"
            style={{ marginRight: 30, marginBottom: 10 }}
            onClick={() =>
              this.setState({
                navigate: true,
                chauffeur: true,
                blanco: false,
                chauffeurinstellingen: false,
                boodschap: false,
                electra: false,
                techniek: false,
                timmeren: false,
                wandelen: false,
                tuin: false,
                liefenleed: false,
                pr: false,
                algemeneklusjes: false,
                klusseninstellingen: false
              })
            }
          >
            chauffeur opdracht
          </Button>
          <Button
            disabled={
              adres === undefined || huisnummer === undefined || postcode === undefined || woonplaats === undefined
            }
            variant="contained"
            color="primary"
            style={{ marginRight: 30, marginBottom: 10 }}
            onClick={() =>
              this.setState({
                navigate: true,
                chauffeur: false,
                blanco: false,
                chauffeurinstellingen: true,
                boodschap: false,
                electra: false,
                techniek: false,
                timmeren: false,
                wandelen: false,
                tuin: false,
                liefenleed: false,
                pr: false,
                algemeneklusjes: false,
                klusseninstellingen: false
              })
            }
          >
            chauffeurinstellingen opdracht
          </Button>
          <Button
            disabled={
              adres === undefined || huisnummer === undefined || postcode === undefined || woonplaats === undefined
            }
            variant="contained"
            color="primary"
            style={{ marginRight: 30, marginBottom: 10 }}
            onClick={() =>
              this.setState({
                navigate: true,
                chauffeur: false,
                blanco: true,
                chauffeurinstellingen: false,
                boodschap: false,
                electra: false,
                techniek: false,
                timmeren: false,
                wandelen: false,
                tuin: false,
                liefenleed: false,
                pr: false,
                algemeneklusjes: false,
                klusseninstellingen: false
              })
            }
          >
            blanco opdracht
          </Button>
          <Button
            disabled={
              adres === undefined || huisnummer === undefined || postcode === undefined || woonplaats === undefined
            }
            variant="contained"
            color="primary"
            style={{ marginRight: 30, marginBottom: 10 }}
            onClick={() =>
              this.setState({
                navigate: true,
                chauffeur: false,
                blanco: false,
                chauffeurinstellingen: false,
                boodschap: true,
                electra: false,
                techniek: false,
                timmeren: false,
                wandelen: false,
                tuin: false,
                liefenleed: false,
                pr: false,
                algemeneklusjes: false,
                klusseninstellingen: false
              })
            }
          >
            Boodschap opdracht
          </Button>
          <Button
            disabled={
              adres === undefined || huisnummer === undefined || postcode === undefined || woonplaats === undefined
            }
            variant="contained"
            color="primary"
            style={{ marginRight: 30, marginBottom: 10 }}
            onClick={() =>
              this.setState({
                navigate: true,
                chauffeur: false,
                blanco: false,
                chauffeurinstellingen: false,
                boodschap: false,
                electra: true,
                techniek: false,
                timmeren: false,
                wandelen: false,
                tuin: false,
                liefenleed: false,
                pr: false,
                algemeneklusjes: false,
                klusseninstellingen: false
              })
            }
          >
            Electra opdracht
          </Button>
          <Button
            disabled={
              adres === undefined || huisnummer === undefined || postcode === undefined || woonplaats === undefined
            }
            variant="contained"
            color="primary"
            style={{ marginRight: 30, marginBottom: 10 }}
            onClick={() =>
              this.setState({
                navigate: true,
                chauffeur: false,
                blanco: false,
                chauffeurinstellingen: false,
                boodschap: false,
                electra: false,
                techniek: true,
                timmeren: false,
                wandelen: false,
                tuin: false,
                liefenleed: false,
                pr: false,
                algemeneklusjes: false,
                klusseninstellingen: false
              })
            }
          >
            Techniek opdracht
          </Button>
          <Button
            disabled={
              adres === undefined || huisnummer === undefined || postcode === undefined || woonplaats === undefined
            }
            variant="contained"
            color="primary"
            style={{ marginRight: 30, marginBottom: 10 }}
            onClick={() =>
              this.setState({
                navigate: true,
                chauffeur: false,
                blanco: false,
                chauffeurinstellingen: false,
                boodschap: false,
                electra: false,
                techniek: false,
                timmeren: true,
                wandelen: false,
                tuin: false,
                liefenleed: false,
                pr: false,
                algemeneklusjes: false,
                klusseninstellingen: false
              })
            }
          >
            Timmeren opdracht
          </Button>
          <Button
            disabled={
              adres === undefined || huisnummer === undefined || postcode === undefined || woonplaats === undefined
            }
            variant="contained"
            color="primary"
            style={{ marginRight: 30, marginBottom: 10 }}
            onClick={() =>
              this.setState({
                navigate: true,
                chauffeur: false,
                blanco: false,
                chauffeurinstellingen: false,
                boodschap: false,
                electra: false,
                techniek: false,
                timmeren: false,
                wandelen: true,
                tuin: false,
                liefenleed: false,
                pr: false,
                algemeneklusjes: false,
                klusseninstellingen: false
              })
            }
          >
            Wandelen opdracht
          </Button>
          <Button
            disabled={
              adres === undefined || huisnummer === undefined || postcode === undefined || woonplaats === undefined
            }
            variant="contained"
            color="primary"
            style={{ marginRight: 30, marginBottom: 10 }}
            onClick={() =>
              this.setState({
                navigate: true,
                chauffeur: false,
                blanco: false,
                chauffeurinstellingen: false,
                boodschap: false,
                electra: false,
                techniek: false,
                timmeren: false,
                wandelen: false,
                tuin: true,
                liefenleed: false,
                pr: false,
                algemeneklusjes: false,
                klusseninstellingen: false
              })
            }
          >
            Tuin opdracht
          </Button>
          <Button
            disabled={
              adres === undefined || huisnummer === undefined || postcode === undefined || woonplaats === undefined
            }
            variant="contained"
            color="primary"
            style={{ marginRight: 30, marginBottom: 10 }}
            onClick={() =>
              this.setState({
                navigate: true,
                chauffeur: false,
                blanco: false,
                chauffeurinstellingen: false,
                boodschap: false,
                electra: false,
                techniek: false,
                timmeren: false,
                wandelen: false,
                tuin: false,
                liefenleed: true,
                pr: false,
                algemeneklusjes: false,
                klusseninstellingen: false
              })
            }
          >
            Lief en Leed opdracht
          </Button>
          <Button
            disabled={
              adres === undefined || huisnummer === undefined || postcode === undefined || woonplaats === undefined
            }
            variant="contained"
            color="primary"
            style={{ marginRight: 30, marginBottom: 10 }}
            onClick={() =>
              this.setState({
                navigate: true,
                chauffeur: false,
                blanco: false,
                chauffeurinstellingen: false,
                boodschap: false,
                electra: false,
                techniek: false,
                timmeren: false,
                wandelen: false,
                tuin: false,
                liefenleed: false,
                pr: true,
                algemeneklusjes: false,
                klusseninstellingen: false
              })
            }
          >
            PR opdracht
          </Button>
          <Button
            disabled={
              adres === undefined || huisnummer === undefined || postcode === undefined || woonplaats === undefined
            }
            variant="contained"
            color="primary"
            style={{ marginRight: 30, marginBottom: 10 }}
            onClick={() =>
              this.setState({
                navigate: true,
                chauffeur: false,
                blanco: false,
                chauffeurinstellingen: false,
                boodschap: false,
                electra: false,
                techniek: false,
                timmeren: false,
                wandelen: false,
                tuin: false,
                liefenleed: false,
                pr: false,
                algemeneklusjes: true,
                klusseninstellingen: false
              })
            }
          >
            Algemene klusjes opdracht
          </Button>
          <Button
            disabled={
              adres === undefined || huisnummer === undefined || postcode === undefined || woonplaats === undefined
            }
            variant="contained"
            color="primary"
            style={{ marginRight: 30, marginBottom: 10 }}
            onClick={() =>
              this.setState({
                navigate: true,
                chauffeur: false,
                blanco: false,
                chauffeurinstellingen: false,
                boodschap: false,
                electra: false,
                techniek: false,
                timmeren: false,
                wandelen: false,
                tuin: false,
                liefenleed: false,
                pr: false,
                algemeneklusjes: false,
                klusseninstellingen: true
              })
            }
          >
            klussen instellingen opdracht
          </Button>
          <h5 style={{ color: '#cecece', fontSize: 9 }}>
            Laatst gewijzigd door: {zz_gebruikersNaam} op {zz_lastupdate} id = {klant.id}
          </h5>
          <form />
        </Modal>
        <Paper zdepth={1}>
          <Grid>
            <Row>
              <Col xs={1} sm={1} lg={1} xl={1}>
                {gebruikersrollen.search('admin') > -1 && (
                  <Button style={styles.iconred} onClick={this.onPressDelete}>
                    <DeleteIcon /> Verwijder
                  </Button>
                )}
              </Col>
              {/* <Col xs={1} sm={1}>
                <Button onClick={this.openModal}>
                  <EditIcon />
                </Button>
              </Col> */}
              <Col xs={5} sm={5} lg={5} xl={5} style={myVrijwilliger} bsClass="float-left" onClick={this.openModal}>
                <Button style={styles.icongreen} onClick={this.openModal}>
                  <EditIcon /> Wijzig {voornaam || ''} {tussenvoegsel || ''} {achternaam || ''}.
                </Button>
              </Col>
              {/* <Col
                xs={5}
                sm={5}
                lg={5}
                xl={5}
                style={myVrijwilliger}
                bsClass="float-left"
                onClick={this.openModalOpdracht}
              >
                Klik hier om opdracht in te voeren voor {voornaam || ''} {tussenvoegsel || ''} {achternaam || ''}.
              </Col> */}
            </Row>
          </Grid>
          <Divider />
        </Paper>
      </div>
    );
  }

  onPressDelete = async () => {
    if (window.confirm('Weet u zeker dat u deze klant wilt verwijderen?')) {
      const { klant } = this.props;
      if (this._deleting) return;
      this._deleting = true;
      try {
        if (klant.data.rollen) {
          alert('Klant heeft rollen (' + klant.data.rollen + ') en kan niet verwijderd worden. Contact Pierre!!');
        } else {
          await klant.delete();
          this._deleting = false;
        }
      } catch (err) {
        this._deleting = false;
      }
    }
  };

  onPressCheck = async () => {
    const { klant } = this.props;
    await klant.update({
      finished: !klant.data.finished
    });
  };

  onTextChange = async event => {
    const { klant } = this.props;
    await klant.update({
      text: event.target.value
    });
  };
}

export default observer(Klant);



// WEBPACK FOOTER //
// ./src/components/Klanten/Klant.jsx